export default function DirectAnswerBlock() {
  return <section id="direct-answer-block" className="py-12 md:py-16 bg-card-foreground text-secondary">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <p className="text-lg md:text-xl leading-relaxed font-default font-medium text-center md:text-left">
          Manufacturing plant labeling is the plant-wide identification across a factory floor — equipment and machine nameplates, safety and warning labels, panel marking, and serialized asset tags for maintenance and inventory tracking. Evermark Industrial Solutions produces this identification in engraved metal and phenolic from one source, matched to the plant's scheme and durable for the floor environment.
        </p>
      </div>
    </section>;
}